import React from 'react';
import { Paper } from '@mui/material';

interface FooterProps {
  height?: string;
  children: React.ReactNode;
}

const Footer: React.FC<FooterProps> = ({ height, children }) => {
  return (
    <Paper
      square
      elevation={2}
      sx={{
        height: height,
        marginTop: '10px',
        position: 'sticky',
        bottom: 10,
        left: 0,
        right: 0,
        zIndex: 1100, // Above MUI Fab (theme.zIndex.fab = 1050) so sticky footer stays on top of edit icons
        display: 'flex',
        alignItems: 'center',
        padding: theme => theme.spacing(2),
        // backgroundColor: theme => theme.palette.grey[500],
        color: theme => theme.palette.text.primary,
        boxShadow: theme => theme.shadows[4],
        borderRadius: '8px',
      }}
    >
      {children}
    </Paper>
  );
};

export default Footer;
